import type { AudienceScope } from '../../types/broadcast';

// Human-readable summaries of an audienceScope for the list + detail surfaces.

// The brand label: "All brands" for an 'all' send, else the chosen brand
// name(s) joined (resolved via the supplied id→name lookup).
export function brandLabel(scope: AudienceScope, accountName: (id: string) => string): string {
  if (scope.brandSelection === 'all') return 'All brands';
  const ids = scope.brandSelection.brandAccountIds;
  if (ids.length === 0) return '—';
  return ids.map((id) => accountName(id)).join(', ');
}

// A short count of the selected accounts (the literal selection drives the
// audience; 'all' has no explicit selection list).
export function audienceCountLabel(scope: AudienceScope): string {
  if (scope.brandSelection === 'all') return 'all accounts';
  const n = scope.selectedAccountIds.length;
  return `${n} account${n === 1 ? '' : 's'}`;
}
